var map = {
	"./bank.svg": 27140,
	"./binance.svg": 53596,
	"./binanceus.svg": 31796,
	"./bitstamp.svg": 94156,
	"./coinbase-white.svg": 7724,
	"./coinbase.svg": 83556,
	"./coinbaseWallet.svg": 84188,
	"./crypto-wallet.svg": 75632,
	"./gemini.svg": 54149,
	"./kraken.svg": 88624,
	"./metaMask.svg": 40100,
	"./okcoin-white.svg": 75172,
	"./okcoin.svg": 3180,
	"./walletConnect.svg": 52408
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 45579;